import styled from "@xstyled/styled-components";
import TailwindTheme from "../../theme/TailwindTheme";
import { Button } from "antd";
import { ButtonProps } from "antd/lib/button";

const SuccessButton: React.SFC<ButtonProps> = styled(Button)`
  background-color: ${TailwindTheme.colors.green[500]};
  border-color: ${TailwindTheme.colors.green[500]};
  color: white;
  :hover {
    background-color: ${TailwindTheme.colors.green[400]};
    border-color: ${TailwindTheme.colors.green[400]};
    color: white;
  }
  :focus {
    background-color: ${TailwindTheme.colors.green[500]};
    border-color: ${TailwindTheme.colors.green[500]};
    color: white;
  }
  :active {
    background-color: ${TailwindTheme.colors.green[700]};
    border-color: ${TailwindTheme.colors.green[700]};
    color: white;
  }
`;

export default SuccessButton;
